import LazyImg from 'App/Components/LazyImg';
import { useObserveVisibility } from 'App/hooks';
import { useAnalytics } from 'App/Services/Analytics';

import whenIcon from '../../../../../assets/description_exciting-gameplay.png';
import logoIcon from '../../../../../assets/description_logo.png';
import whereIcon from '../../../../../assets/description_lose-game.png';
import polyglot from '../../../../../localization';

import { Card } from './Card';

import './styles.scss';

/**
 * Description component renders the main game description block on the landing page.
 * It includes a primary card with an image, title, and bullet list, followed by two
 * secondary cards. All content is localized using the provided language key.
 *
 * @param {string} lang — Language key used to localize titles, lists, descriptions, and alt texts.
 */

export const Description = ({ lang }) => {
    const { sendGameDesignEvent, sendGoogleEvent } = useAnalytics();
    const visibleRef = useObserveVisibility(() => {
        sendGameDesignEvent('HP:GameDiscriptionVisible');
        sendGoogleEvent('hp_game_discription_visible');
    });

    return (
        <div className='description'>
            <div className='description__item description__item--play' ref={visibleRef}>
                <div className='description__image description__image--play'>
                    <LazyImg
                        src={logoIcon}
                        width={270}
                        height={241}
                        alt={polyglot.t(`${lang}.footer.gameDescription.alt.logo`)}
                    />
                </div>

                <div className='description__content description__content--play'>
                    <h2 className='description__title'>
                        {polyglot.t(`${lang}.footer.gameDescription.playBacanaGolTitle`)}
                    </h2>

                    <ul className='description__list'>
                        <li className='description__list-item'>
                            {polyglot.t(`${lang}.footer.gameDescription.enjoyPossibilityToWin`)}
                        </li>
                        <li className='description__list-item'>
                            {polyglot.t(
                                `${lang}.footer.gameDescription.exploreFootballAndOnlineGaming`
                            )}
                        </li>
                        <li className='description__list-item'>
                            {polyglot.t(`${lang}.footer.gameDescription.takeBreakFromRoutine`)}
                        </li>
                        <li className='description__list-item'>
                            {polyglot.t(`${lang}.footer.gameDescription.marvelAtStunningVisuals`)}
                        </li>
                    </ul>
                </div>
            </div>

            <div className='description__band'>
                <Card
                    src={whenIcon}
                    width={640}
                    height={495}
                    alt={polyglot.t(`${lang}.footer.gameDescription.alt.whenPlaying`)}
                    title={polyglot.t(`${lang}.footer.gameDescription.playBacanaGolSubtitle`)}
                    modifier='when'
                    description={
                        <>
                            <p>
                                {polyglot.t(
                                    `${lang}.footer.gameDescription.perfectEntertainmentMoment`
                                )}
                            </p>

                            <br />

                            <p>
                                {polyglot.t(
                                    `${lang}.footer.gameDescription.accessibleDynamicGameplay`
                                )}
                            </p>

                            <br />

                            <p>
                                {polyglot.t(`${lang}.footer.gameDescription.playAnywhereAnytime`)}
                            </p>
                        </>
                    }
                />
            </div>

            <Card
                src={whereIcon}
                width={500}
                height={460}
                alt={polyglot.t(`${lang}.footer.gameDescription.alt.wherePlaying`)}
                title={polyglot.t(`${lang}.footer.gameDescription.whereToPlayBacanaGol`)}
                modifier='where'
                description={
                    <>
                        <p>{polyglot.t(`${lang}.footer.gameDescription.optimizedForMobile`)}</p>

                        <br />

                        <p>{polyglot.t(`${lang}.footer.gameDescription.bacanaGolCompanion`)}</p>
                    </>
                }
            />
        </div>
    );
};
